module.exports = __webpack_public_path__ + "static/img/200137.24d7b609.png";